import { FilterIcon, MinusIcon, PlusIcon } from '@va/icons';
import { useTranslate } from '@va/localization';
import { GrayGradientDivider, Paragraph, paragraphSizes } from '@va/ui/design-system';
import { DropdownArrow } from '@va/util/components';

export const SegmentsUpgradeTooltipImage = () => {
  const translate = useTranslate();

  return (
    <div className='rounded-24 bg-orange-tan px-18px pt-18px w-300px text-xs leading-18 overflow-hidden'>
      <div className='bg-white-snow -mb-15px rounded-21'>
        <div className='rounded-18px justify-center flex p-2 items-center gap-1'>
          <FilterIcon color='#696969' className='shrink-0 h-3 w-3' />
          <Paragraph className='text-gray-charcoal' size={paragraphSizes.tiny}>
            {
              <>
                {translate('all.upgradePlanTooltip.segments.image.title')}
                <span className='text-red-negative ml-1'>*</span>
              </>
            }
          </Paragraph>
          <DropdownArrow color={'#C3C3C3'} open={false} className='shrink-0 h-3 w-3' />
        </div>
        <GrayGradientDivider />
        <div className='m-6px'>
          {/* first filter row */}
          <div className='h-7 whitespace-nowrap flex-nowrap text-gray-charcoal w-full flex bg-gray-concrete p-0.5 rounded-md items-center gap-0.5 justify-between'>
            <div className='h-full bg-white w-auto px-2 rounded-l-md flex items-center'>
              <Paragraph size={paragraphSizes.tiny}>{translate('filter.operatingSystem')}</Paragraph>
            </div>

            <div className='h-full bg-white px-2 flex items-center'>
              <Paragraph size={paragraphSizes.tiny}>{translate('filters.options.is')}</Paragraph>
            </div>

            <div className='h-full bg-white w-full pl-2 rounded-r-md flex items-center'>
              <Paragraph size={paragraphSizes.tiny}>{'Windows 11'}</Paragraph>
            </div>
            <MinusIcon color='#969696' className='shrink-0 h-3 w-3 mx-2' />
          </div>
          {/* second filter row */}

          <div className='mt-1 mb-2 h-7 whitespace-nowrap flex-nowrap text-gray-charcoal w-full flex bg-gray-concrete p-0.5 rounded-md items-center gap-0.5 justify-between'>
            <div className='h-full bg-white w-auto px-2 rounded-l-md flex items-center'>
              <Paragraph size={paragraphSizes.tiny}>{translate('filters.options.browser')}</Paragraph>
            </div>

            <div className='h-full bg-white px-2 flex items-center'>
              <Paragraph size={paragraphSizes.tiny}>{translate('filters.options.is')}</Paragraph>
            </div>

            <div className='h-full bg-white w-full pl-2 rounded-r-md flex items-center'>
              <Paragraph size={paragraphSizes.tiny}>{'Google Chrome'}</Paragraph>
            </div>
            <MinusIcon color='#969696' className='shrink-0 h-3 w-3 mx-2' />
          </div>

          <div className='rounded-md py-6px gap-1 bg-gray-concrete flex justify-center w-full text-gray-charcoal items-center'>
            <PlusIcon className='h-3 w-3' />
            <Paragraph size={paragraphSizes.tiny}>{translate('button.addNewFilter')}</Paragraph>
          </div>
        </div>
      </div>
    </div>
  );
};
